import React, { useState, useEffect } from 'react';
import { Form, Input, Checkbox, Row, Col, Upload, Radio, Select, DatePicker, InputNumber, Popconfirm, message, Button } from 'antd';
import ImageMapper from 'react-image-mapper'



const ImageComp=({p,updateFormValues, enterArea, leaveArea})=>{

    let imgWidth = '200px';
    if (window) {
      imgWidth = window.screen.width > 650 ? 400 : window.screen.width - 30
    }
  

    let actualWidth = 450;

    if (p.refImage && p.refImage != null) {

      const img = new Image();
      img.onload = function () {

        actualWidth = this.width;
      }
      img.src = `https://${p.refImage.imgUrl.bucket}.s3.${p.refImage.imgUrl.region}.amazonaws.com/${p.refImage.imgUrl.key}`;
    
    }


    return(
        <ImageMapper
        src={`https://${p.refImage.imgUrl.bucket}.s3.${p.refImage.imgUrl.region}.amazonaws.com/${p.refImage.imgUrl.key}`}
        map={{name : p.refImage.imgUrl.key , areas : p.refImage.areas }}
        width={imgWidth}
        // imgWidth={'100%'}
        imgWidth={actualWidth}
        // onLoad={() => {
        //   console.log('in load ', p,props.index)
        // }}
        // record={record}
        onClick={(area, index, e, data) => {
          e.stopPropagation()
          updateFormValues(area)
        }}
        onMouseEnter={area => enterArea && enterArea(area)}
        onMouseLeave={area => leaveArea && leaveArea(area)}
        onImageClick={e => {
          return false
          e.preventDefault()
          // console.log('image click',e.target)
       
          // console.log('layer', e.nativeEvent.layerX, e.nativeEvent.layerY)
          p.refImage.areas.map((item) => {
            if(item.coords && e.nativeEvent.layerX <= item.coords[0]){
              
            }
          })
        }}
        onMouseMove={area => {
      
       // sethoveredArea(area)
      }}
      />
    )
}

export default ImageComp;